export const PWA_SETTINGS = 'pwa_settings';
export const EXCLUDED_PAGES = ['stream-widgets'];

export interface IPwaPromptSettings {
  appLogoPath: string;
  appName: string;
}
